/**
 * @Date:   2018-01-22T12:36:23+08:00
 * @Last modified time: 2018-01-22T22:07:54+08:00
 */
import _util from '../../utils/';

const SystemLoggerService = {
    fetchSystemLogger(params, resolve, reject) {
        _util.request({
            url: '/api/HRSystemLog/Get',
            params: params,
            success: resolve,
            error: reject
        })      
    },
    fetchSystemLoggerSetting(params, resolve, reject) {
        _util.request({
            url: '/api/HRSystemLogSetting/Detail',
            params: params,
            success: resolve,
            error: reject
        })          
    },
    addSystemLoggerSetting(datas, resolve, reject) {
        _util.request({
            url: '/api/HRSystemLogSetting/Post',
            method: 'post',
            data: datas,
            success: resolve,
            error: reject
        })  
    },
    saveSystemLoggerSetting(datas, resolve, reject) {
        _util.request({
            url: '/api/HRSystemLogSetting/Put',
            method: 'put',
            data: datas,
            success: resolve,
            error: reject
        })         
    },
    fetchSystemModule(resolve, reject) {
        _util.request({
            url: '/api/HRSystemLog/Modules',
            success: resolve,
            error: reject
        })  
    }
}

export default SystemLoggerService;



// WEBPACK FOOTER //
// ./src/services/SystemSetting/system-logger-service.js